import app from 'flarum/forum/app';
export function getPerPage() {
  return Number(app.forum.attribute('perPage')) || 20;
}
export function isDiscussionPage() {
  const path = typeof location !== 'undefined' && location.pathname || '';
  return path.startsWith('/d/') || !!document.querySelector('.DiscussionPage');
}
export function getDiscussionModel() {
  try {
    var _app$current, _app$current$get;
    return ((_app$current = app.current) == null || (_app$current$get = _app$current.get) == null ? void 0 : _app$current$get.call(_app$current, 'discussion')) || null;
  } catch (_unused) {
    return null;
  }
}
export function getDiscussionId(discussion) {
  try {
    var _discussion$data;
    if (typeof (discussion == null ? void 0 : discussion.id) === 'function') return String(discussion.id());
    if (discussion != null && (_discussion$data = discussion.data) != null && _discussion$data.id) return String(discussion.data.id);
    if (discussion != null && discussion.id) return String(discussion.id);
  } catch (_unused2) {}
  return '';
}
export function getDiscussionSlug(discussion) {
  try {
    var _discussion$data2;
    if (typeof (discussion == null ? void 0 : discussion.slug) === 'function') return String(discussion.slug());
    if (typeof (discussion == null ? void 0 : discussion.attribute) === 'function') return String(discussion.attribute('slug') || '');
    if (discussion != null && (_discussion$data2 = discussion.data) != null && (_discussion$data2 = _discussion$data2.attributes) != null && _discussion$data2.slug) return String(discussion.data.attributes.slug);
    if (discussion != null && discussion.slug) return String(discussion.slug);
  } catch (_unused3) {}
  return '';
}
export function getLastPostNumber(discussion) {
  let byLast = 0;
  let byCount = 0;
  try {
    var _discussion$data3;
    if (typeof (discussion == null ? void 0 : discussion.lastPostNumber) === 'function') {
      byLast = Number(discussion.lastPostNumber() || 0);
    } else if (typeof (discussion == null ? void 0 : discussion.attribute) === 'function') {
      byLast = Number(discussion.attribute('lastPostNumber') || 0);
    } else if (discussion != null && (_discussion$data3 = discussion.data) != null && (_discussion$data3 = _discussion$data3.attributes) != null && _discussion$data3.lastPostNumber) {
      byLast = Number(discussion.data.attributes.lastPostNumber || 0);
    }
  } catch (_unused4) {}
  try {
    var _discussion$data4;
    if (typeof (discussion == null ? void 0 : discussion.commentCount) === 'function') {
      byCount = Number(discussion.commentCount() || 0) + 1;
    } else if (typeof (discussion == null ? void 0 : discussion.attribute) === 'function') {
      byCount = Number(discussion.attribute('commentCount') || 0) + 1;
    } else if (discussion != null && (_discussion$data4 = discussion.data) != null && (_discussion$data4 = _discussion$data4.attributes) != null && _discussion$data4.commentCount) {
      byCount = Number(discussion.data.attributes.commentCount || 0) + 1;
    }
  } catch (_unused5) {}
  const total = Math.max(byLast, byCount, 1);
  return Number.isFinite(total) && total > 0 ? total : 1;
}
export function getNearFromUrl() {
  const path = typeof location !== 'undefined' && location.pathname || '';
  const match = path.match(/\/d\/[^/]+(?:\/(\d+))?/);
  const near = match != null && match[1] ? parseInt(match[1], 10) : 1;
  return Number.isFinite(near) && near > 0 ? near : 1;
}
export function getTotalPages(discussion) {
  return Math.max(1, Math.ceil(getLastPostNumber(discussion) / getPerPage()));
}
export function getCurrentPage(totalPages) {
  const perPage = getPerPage();
  const near = getNearFromUrl();
  const page = Math.ceil(near / perPage);
  return Math.min(Math.max(page, 1), totalPages);
}
export function makeDiscussionPath(discussion, page) {
  const id = getDiscussionId(discussion);
  const slug = getDiscussionSlug(discussion);
  const safePage = Math.max(1, page);
  const near = (safePage - 1) * getPerPage() + 1;
  if (!id || !slug) return location.pathname;
  return safePage <= 1 ? "/d/".concat(id, "-").concat(slug) : "/d/".concat(id, "-").concat(slug, "/").concat(near);
}
export function navigateToDiscussionPage(discussion, page) {
  const path = makeDiscussionPath(discussion, page);
  try {
    var _m$route;
    if (typeof m !== 'undefined' && typeof ((_m$route = m.route) == null ? void 0 : _m$route.set) === 'function') {
      m.route.set(path);
      return;
    }
  } catch (_unused6) {}
  window.location.assign(path);
}
export function currentUrlKey() {
  const p = typeof location !== 'undefined' && location.pathname || '';
  const s = typeof location !== 'undefined' && location.search || '';
  const h = typeof location !== 'undefined' && location.hash || '';
  return p + s + h;
}
flarum.reg.add('forumaker-magicread', 'forum/components/paginationUtils', { getPerPage: getPerPage,isDiscussionPage: isDiscussionPage,getDiscussionModel: getDiscussionModel,getDiscussionId: getDiscussionId,getDiscussionSlug: getDiscussionSlug,getLastPostNumber: getLastPostNumber,getNearFromUrl: getNearFromUrl,getTotalPages: getTotalPages,getCurrentPage: getCurrentPage,makeDiscussionPath: makeDiscussionPath,navigateToDiscussionPage: navigateToDiscussionPage,currentUrlKey: currentUrlKey, });